:host {
  display: block;
}

uic-message-list-item {
  --message-column-width: calc((100% - 68px - 16px) * 0.33);

  @media only screen and (min-width: 1920px) {
    --uic-message-list-cell-width: 386px;
    --uic-message-list-icon-size: 43px;
    --uic-message-list-icon-eye: 60px;
    --uic-font-size-small: 13px;
    --uic-message-list-dual-button-offset: -24px;
  }

  @media only screen and (max-width: 1919px) {
    --uic-message-list-cell-width: 320px;
    --uic-message-list-icon-size: 36px;
    --uic-message-list-icon-eye: 50px;
    --uic-font-size-small: 12px;
    --uic-message-list-dual-button-offset: -16px;
  }

  @media only screen and (max-width: 1023px) {
    --uic-message-list-cell-width: 266px;
    --uic-message-list-icon-size: 30px;
    --uic-message-list-icon-eye: 42px;
    --uic-font-size-small: 10px;
    --uic-message-list-dual-button-offset: -8px;
  }
}

.uic-message-list-item {
  &__message-container-min,
  &__message-container-max {
    border-bottom: 1px solid var(--uic-color-grey2);
    cursor: pointer;
    display: grid;
    grid-template-rows: 12px 20px 18px 4px 62px 12px;
    height: 128px;
    overflow: visible;
  }

  &__message-container-max-history {
    cursor: auto;
  }

  &__message-container-min {
    --message-column-width: calc((100% - 52px - 66px - 16px) * 0.5);
    grid-template-columns:
      52px var(--message-column-width) var(--message-column-width)
      66px 16px;
    width: var(--uic-message-list-cell-width);
  }

  &__message-container-max {
    grid-template-columns:
      68px var(--message-column-width) var(--message-column-width)
      var(--message-column-width) 16px;
  }

  &__message-container-max--sub {
    --message-column-width-sub: calc(var(--message-column-width) - 12px);
    --message-column-width-sub2: calc(var(--message-column-width) + 12px);
    background-color: var(--uic-color-grey7);
    cursor: auto;
    grid-template-columns:
      68px var(--message-column-width-sub) var(--message-column-width-sub2)
      var(--message-column-width) 16px;
    margin-left: 16px;
  }

  &__header-min,
  &__header-max {
    display: flex;
    height: 36px;
    margin-top: 14px;
  }

  &__header-min {
    width: var(--uic-message-list-cell-width);
  }

  &__header-max {
    width: 100%;
  }

  &__icon__wrapper {
    box-sizing: border-box;
    display: inline-block;
    position: relative;
  }

  &__icon__wrapper__icon {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    pointer-events: none;

    svg {
      height: var(--uic-message-list-icon-size);
      width: var(--uic-message-list-icon-size);
    }
  }

  &__icon-min,
  &__icon-max {
    grid-column: 1 / 2;
    grid-row: 2 / 4;
    justify-self: center;
    vertical-align: middle;
  }

  &__icon-max {
    margin-left: 16px;
    padding-left: 0;
    padding-right: 0;
    padding-top: 3px;
    width: var(--uic-message-list-icon-size) !important;
  }

  &__title-min,
  &__title-max {
    color: var(--uic-color-blue4);
    font-size: var(--uic-font-size-normal);
    font-weight: var(--uic-font-weight-bold);
    grid-row: 3 / 4;
    height: 19px;
    letter-spacing: 0;
    line-height: var(--uic-line-height-small);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }

  &__title-min {
    grid-column: 2 / 5;
  }

  &__title-max {
    grid-column: 2 / 4;
  }

  &__app {
    align-self: center;
    color: var(--uic-color-black);
    color: var(--uic-color-blue4);
    cursor: pointer;
    font-size: var(--uic-font-size-small);
    font-weight: var(--uic-font-weight-semibold);
    grid-column: 3 / 5;
    grid-row: 2 / 3;
    height: 18px;
    justify-self: end;
    letter-spacing: 0;
    line-height: var(--uic-line-height-extrasmall);
    overflow: hidden;
    text-align: right;
    text-decoration: underline;
    text-overflow: ellipsis;
    text-underline-offset: 3px;
    white-space: nowrap;
  }

  &__id {
    align-self: center;
    color: var(--uic-color-black);
    cursor: default;
    font-size: var(--uic-font-size-normal);
    font-weight: var(--uic-font-weight-semibold);
    grid-column: 2 / 3;
    grid-row: 2 / 3;
    height: 17px;
    justify-self: start;
    letter-spacing: 0;
    line-height: var(--uic-line-height-extrasmall);
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: top;
    white-space: nowrap;
    width: 100%;
  }

  &__message-text-min,
  &__message-text-max,
  &__message-text-center-max,
  &__message-text-center-link {
    -webkit-box-orient: vertical;
    color: var(--uic-color-black);
    /* stylelint-disable declaration-property-value-disallowed-list, value-no-vendor-prefix, property-no-vendor-prefix */
    /* webkit not supported by IE, but currently no other good solution is available for multiline text with ellipsis.  */
    display: -webkit-box;
    font-size: var(--uic-font-size-normal);
    grid-row: 5 / 6;
    height: calc(var(--uic-line-height-normal) * 3);
    letter-spacing: 0;
    -webkit-line-clamp: 3;
    line-height: var(--uic-line-height-normal);
    overflow: hidden;
    /* stylelint-enable declaration-property-value-disallowed-list, value-no-vendor-prefix, property-no-vendor-prefix */
    padding-right: 24px;
    text-overflow: ellipsis;
    white-space: normal;
    width: 90%;
  }

  &__message-text-min {
    grid-column: 2 / 4;
  }

  &__message-text-max {
    grid-column: 2 / 3;
  }

  &__message-text-center-max {
    grid-column: 3 / 4;
    height: 36px;
    -webkit-line-clamp: 2;
  }

  &__message-text-center-link {
    align-self: end;
    color: var(--uic-color-blue4);
    cursor: pointer;
    grid-column: 3 / 4;
    height: 23px;
    padding-right: 0;
    text-decoration: underline;
    text-underline-offset: 3px;
    width: fit-content;
  }

  &__date,
  &__time {
    align-self: start;
    color: var(--uic-color-black);
    display: inline-flex;
    font-family: OpenSans, sans-serif;
    /*OpenSans-Regular*/
    font-size: var(--uic-font-size-small);
    grid-column: 4 / 5;
    height: 18px;
    justify-content: space-between;
    justify-self: end;
    letter-spacing: 0;
    line-height: var(--uic-line-height-extrasmall);
    overflow: hidden;
  }

  &__date {
    grid-row: 3 / 4;
  }

  &__time {
    grid-row: 4 / 5;
  }

  &__date--sub {
    grid-row: 2 / 3;
  }

  &__time--sub {
    grid-row: 3 / 4;
  }

  &__message-container-max--sub-last {
    border-bottom: transparent;
  }

  &__sub-message-container {
    border-bottom: 1px solid var(--uic-color-grey2);
  }

  &__message-button {
    align-self: end;
    background: var(--uic-color-white);
    grid-column: 4 / 5;
    grid-row: 5 / 6;
    height: calc(var(--uic-message-list-icon-eye) * 0.8);
    justify-self: end;
    padding: 0;
    width: var(--uic-message-list-icon-eye);
  }

  &__message-button--second {
    margin-left: 9px;
  }

  &__message-button--completed {
    align-self: flex-end;
    fill: var(--uic-color-limone);
    margin-right: 12px;
    padding-bottom: 4px;

    use {
      transform: scale(1.95);
      transform-origin: center;
    }
  }

  &__message-dual-button-max,
  &__message-dual-button-min {
    align-self: end;
    grid-row: 5 / 6;
    justify-self: end;
    padding: 0;
  }

  &__message-dual-button-max {
    grid-column: 4 / 5;
  }

  &__message-dual-button-min {
    grid-column: 3 / 6;
    margin-right: var(--uic-message-list-dual-button-offset);
  }

  &__message-flyout-footer {
    border-top: var(--uic-color-black) solid 1px;
    font-size: var(--uic-font-size-medium);
    font-weight: var(--uic-font-weight-bold);
    margin-top: 2px;
    padding: 6px 12px 12px;
  }

  &__hide {
    display: none;
  }

  &__title--error {
    color: var(--uic-color-red2);
  }

  &__expand-arrow {
    align-self: end;
    grid-column: 1 / 2;
    grid-row: 5 / 6;
    height: var(--uic-icon-dimensions-default);
    justify-self: center;
    margin-left: 12px;
    width: var(--uic-icon-dimensions-default);
  }

  &__message-committed-by {
    align-self: end;
    display: flex;
    grid-column: 4 / 5;
    grid-row: 5 / 6;
    height: var(--uic-icon-height);
    justify-content: space-between;
    justify-self: left;
    width: 100%;
  }

  &__message-committed-by-preset-text {
    font-size: var(--uic-font-size-small);
  }

  &__message-committed-by-username {
    font-weight: var(--uic-font-weight-semibold);
    line-height: var(--uic-line-height-normal);
  }

  &__new-message {
    font-weight: var(--uic-font-weight-semibold);
  }

  &__new-message--extrabold {
    font-weight: var(--uic-font-weight-extrabold);
  }
}
